if (typeof window.LADS === "undefined") {
    window.LADS = {};
}

// Polyfill NodeList.forEach(...)
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// Polyfill CustomEvent (IE jusqu'à 11)
(function() {
   if (typeof window.CustomEvent === "function") return false; //If not IE

   function CustomEvent (event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
   }

   CustomEvent.prototype = window.Event.prototype;

   window.CustomEvent = CustomEvent;
})();

// IE 11
if (!Object.entries) {
  Object.entries = function( obj ){
    var ownProps = Object.keys( obj ),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

function doXHR(method, url, data, callback) {
   if (!method) {
      var method = "GET";
   }

   if (!data) {
      var data = {};
   }

   var xhr = new XMLHttpRequest();
   document.body.classList.add("async-loading");

   xhr.onreadystatechange = function () {
      if (this.readyState == XMLHttpRequest.DONE) {
         document.body.classList.remove("async-loading");

         if (this.status == 200) {
            callback(this.responseText);
         }
      }
   };

   xhr.open(method, url);
   xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

   if (method === "POST" || method === "post") {
      if (data instanceof FormData) {
         xhr.send(data);
      } else {
         xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

         let urlEncodedDataPairs = [];
         for (name in data) {
            urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
         }

         // On transforme les espaces %20 en + pour coller au comportement du navigateur
         let urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');
         xhr.send(urlEncodedData);
      }
   } else {
      xhr.send(null);
   }
}

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

function strpos(haystack, needle, offset)
{
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: strpos('Kevin van Zonneveld', 'e', 5);
    // *     returns 1: 14

    var i = haystack.indexOf(needle, offset); // returns -1
    return i >= 0 ? i : false;
}

function substr(f_string, f_start, f_length)
{
    // http://kevin.vanzonneveld.net
    // +     original by: Martijn Wieringa
    // *         example 1: substr('abcdef', 0, -1);
    // *         returns 1: 'abcde'

    if (f_start < 0) {
        f_start += f_string.length;
    }

    if (f_length == undefined) {
        f_length = f_string.length;
    } else if (f_length < 0) {
        f_length += f_string.length;
    } else {
        f_length += f_start;
    }

    if (f_length < f_start) {
        f_length = f_start;
    }

    return f_string.substring(f_start, f_length);
}

// Alternative to switch, functional-style
// https://codeburst.io/alternative-to-javascripts-switch-statement-with-a-functional-twist-3f572787ba1c
const match = x => ({
   on: (pred, fn) => {
      const matched = x => ({
         on: () => matched(x),
         otherwise: () => x,
      })

      if (typeof pred !== "function") {
         let value = pred;
         pred = x => x == value;
      }

      if (typeof fn !== "function") {
         let value = fn;
         fn = () => value;
      }

      return (pred(x) ? matched(fn(x)) : match(x));
   },
   otherwise: fn => {
      if (typeof fn !== "function") {
         let value = fn;
         fn = () => value;
      }

      return fn(x);
   },
})

// En attendant de remplacer ça par un meilleur système, on le met ici pour ne pas le réserver aux formulaires
function Uncheck(checks) {
   for (i = 0; i < checks.length; i++) {
      if (checks[i]) {
         var id = document.getElementById(checks[i]);
         if (id) id.checked = false;
      }
   }
}

// Debounce
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
   var timeout;
   return function () {
      var context = this, args = arguments;
      var later = () => {
         timeout = null;
         if (!immediate) {
            func.apply(context, args);
         }
      };
      var callNow = immediate && !timeout;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(later, wait);
      if (callNow) {
         func.apply(context, args);
      }
   };
};

function throttle (func, delay) {
   let lastFunc;
   let lastRan;

   return function () {
      var context = this, args = arguments;
      if (!lastRan) {
         func.apply(context, args);
         lastRan = Date.now();
      } else {
         window.clearTimeout(lastFunc);
         lastFunc = window.setTimeout(() => {
            if ((Date.now() - lastRan) >= delay) {
               func.apply(context, args);
               lastRan = Date.now();
            }
         }, delay - (Date.now() - lastRan))
      }
   }
};

this.LADS = this.LADS || {};
this.LADS.Regions = {
   init: function (firstSelect) {

      var afterInit = function () {
         // Une fois que tout est initialisé, on met un listener pour que
         // le select réagisse aux changements manuels futurs
         firstSelect.addEventListener("change", function(evt) {
            window.LADS.Regions.getNext(firstSelect.dataset.regionClass, firstSelect, firstSelect.value, 1);
         });

         // Si on n'a pas de selects sous-régions, on amorce le chargement du premier sous-niveau
         if (document.querySelectorAll(
            "[data-region-class=" + firstSelect.dataset.regionClass + "]")
            .length <= 1) {
            firstSelect.dispatchEvent(new CustomEvent('change'));
         }
      };

      var params = [firstSelect.name, "selectRegion1", "selectRegion2"];

      (function check(i, select) {
         if (i < params.length) {
            var value = findGetParameter(params[i]);

            if (value) {
               select.value = value;

               window.LADS.Regions.getNext('filtre-region', select,
                     select.dataset.regionPays || select.value,
                     parseInt(select.dataset.regionNiveau, 10) + 1 || 1)
                  .then(
                     function success (newSelect) {
                        check(i+1, newSelect);
                     },
                     function nope () {
                        afterInit();
                     }
               );
            } else {
               afterInit();
            }
         }
      })(0, firstSelect);
   },

   insertSelect: function (regions, classe, select, pays, niveau, selected) {
      // Création du select
      var selectRegion = document.createElement("select");
      selectRegion.className = "select-region-" + niveau;
      selectRegion.setAttribute("data-region-class", classe);
      selectRegion.setAttribute("data-region-niveau", niveau);
      selectRegion.setAttribute("data-region-pays", pays);
      selectRegion.name = selectRegion.id = "selectRegion" + niveau;
      // Ajout d'un <option> vide
      selectRegion.appendChild(document.createElement("option"));

      // Ajout des <option>s correspondant aux régions
      var selectedOption = null;
      regions.forEach(function (v) {
         var option = document.createElement("option");
         option.value = v.CodeRegion;
         option.innerHTML = v.NomRegion;
         selectRegion.appendChild(option);
         if (typeof selected !== "undefined" && v.CodeRegion === selected) {
            option.selected = true;
         }
      });

      // Insertion du nouveau select après le select d'origine
      select.parentNode.insertBefore(selectRegion, select.nextSibling);

      // Listener sur le nouveau select pour qu'il affiche ses sous-régions
      selectRegion.addEventListener("change", function() {
         window.LADS.Regions.getNext(classe, selectRegion, pays, niveau + 1);
         window.dispatchEvent(new CustomEvent("changeSelectRegion", {detail: {
            pays: pays,
            niveau: niveau,
            region: selectRegion.options[selectRegion.selectedIndex].value,
            classe: classe
         }}));
      });

      return selectRegion;
   },

   getNext: function (classe, select, pays, niveau) {
      var url = LADS.Root + "/int-api.php?action=getRegions&niveau=" + niveau;
      if (pays) {
         url += "&pays=" + pays;
      }
      if (niveau > 1) {
         url += "&parent=" + select.options[select.selectedIndex].value;
      }

      return new Promise(function (resolve, reject) {
         doXHR("GET", url, {}, function (response) {
            var regions = JSON.parse(response);

            // Suppression des selects à remplacer
            var obsoleteSelects = select.parentElement
               .querySelectorAll("[data-region-class=" + classe + "]");

            obsoleteSelects.forEach(function (element) {
               if (element.dataset.regionNiveau >= niveau) {
                  element.parentNode.removeChild(element);
               }
            });

            if (regions.length > 0) {
               var newSelect = LADS.Regions.insertSelect(regions, classe, select, pays, niveau);
               window.dispatchEvent(new CustomEvent("loadedRegions", {detail: { class: classe, niveau: niveau }}));

               resolve(newSelect);
            } else {
               reject();
            }

            if (niveau < 2) {
               // Changement de pays : region à null (pour cacher le tr villes)
               window.dispatchEvent(new CustomEvent("changeSelectRegion", {detail: {
                  pays: pays,
                  niveau: niveau,
                  region: null
               }}));
            }
         });
      });
   },
};

window.dispatchEvent(new CustomEvent("LADSRegionsReady"));


/** Fonctions spécifiques au frontend LADS (non-MRP)
 *
 * inclure le code concernant par exemple le menu, mais pas du code
 * utilisées dans les fiches car main.mrp.js en a besoin aussi
 */

LADS.callWhenDOMLoaded(function() {
   const searchInput = document.querySelector(".js-search-input");

   // Raccourci sur la touche `/` pour effectuer une recherche
   window.addEventListener("keypress", event => {
      if (
         event.key === "/"
         && !(event.target instanceof HTMLInputElement)
         && !(event.target instanceof HTMLTextAreaElement)
         && !(event.target instanceof HTMLSelectElement)
      ) {
         event.preventDefault();

         searchInput.focus();
         searchInput.select();
      }
   });
});


function visionnerADS(sens) {
    var i, id_image, id_imageN, id_copyright, id_copyrightN;
    var visionneuseADS = document.getElementById('visionneuseADS');
    if (!visionneuseADS) {
        return;
    }
    nbMax = visionneuseADS.children.length;
    for (i = 1; i <= nbMax; i++)
    {
        id_image = visionneuseADS.querySelector('.image_' + i);
        if (id_image.style.display == 'block') {
            break;
        }
    }
    j = (sens) ? (i + 1) : (i - 1);
    if (j <= 0) {
        j = nbMax;
    } else if (j > nbMax) {
        j = 1;
    }
    id_imageN = visionneuseADS.querySelector('.image_' + j);
    id_image.style.display = 'none';
    id_imageN.style.display = 'block';
}

function detailsR(idRole)
{
    id_details1 = document.getElementById('dtlR_' + idRole);
    id_bouton1 = document.getElementById('btnR_' + idRole);
    if (id_details1 && id_bouton1) {
        if (id_details1.style.display == 'none') {
            id_details1.style.display = 'block';
            id_bouton1.innerHTML = "&#9650;";
        }
        else {
            id_details1.style.display = 'none';
            id_bouton1.innerHTML = "&#9660;";
        }
    }
    LADS.adjustResize();
}


function resetLog() {
   var MT_log = document.getElementById("MT_log");
   if (MT_log) {
      MT_log.parentElement.removeChild(MT_log);
   }
}

function checkRequiredEmail() {
   var pasDeReponse = document.getElementById("cbPDR").checked;
   var recevoirUneCopie = document.getElementById("cbCopie").checked;
   var champEmail = document.getElementById("MT_email");

   if (pasDeReponse && !recevoirUneCopie) {
      champEmail.disabled = true;
      champEmail.removeAttribute("required");
   } else {
      champEmail.disabled = false;
      champEmail.setAttribute("required", "required");
   }
}

(function () {
   function initAsyncMailingSubscribe() {
      var form = document.querySelector(".bloc-lettre-information form");
      var feedbackZone = document.querySelector(".bloc-lettre-information__feedback");
      if (form && feedbackZone) {
         form.querySelectorAll("input").forEach(function (input) {
            input.addEventListener("keypress", function (event) {
               while (feedbackZone.lastChild) {
                  feedbackZone.removeChild(feedbackZone.lastChild);
               }
            });
         });

         form.addEventListener("submit", function (event) {
            event.preventDefault();

            while (feedbackZone.lastChild) {
               feedbackZone.removeChild(feedbackZone.lastChild);
            }

            var data = {
               email: form.querySelector("#MT_email").value,
               honeypot: form.querySelector("#MT_info").value,
               turing_id: form.querySelector("[name=turing_id]").value,
               turing_answer: form.turing_answer.value, // radio buttons, il ne faut pas utiliser querySelector ici
               then: form.querySelector("[name=then]").value, // timestamp
               subscribe: true,
            };

            doXHR("POST", LADS.Root + "/async?action=mailing-subscribe", data, function (response) {
               var response;

               try {
                  response = JSON.parse(response);
               } catch (e) {
                  response = {
                     success: false
                  };
               }

               var feedback = document.createElement("p");
               feedback.classList.add("message");

               feedback.innerHTML = response.info;
               if (response.success) {
                  feedback.dataset.type = "success";
               } else {
                  feedback.dataset.type = "error";
               }
               feedbackZone.appendChild(feedback);
            });
         });
      }
   }

   if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", initAsyncMailingSubscribe);
   } else {
      initAsyncMailingSubscribe();
   }
})();


(function () {

// window.addEventListener("popstate", event => {
//    console.log("popstate", event.state);

//    if (event.state !== null) {
//       // L’URL a été modifiée après un appel de formulaire asynchrone
//       // puis l’utilisateur a fait Précédent. On recharge alors toute la page
//       // pour que le contenu corresponde à l’adresse.
//       // Idéalement il faudrait que ce chargement se fasse en asynchrone aussi,
//       // mais pour l’instant ça pose trop de soucis.
//       // Problème : sur les onglets, on a un popstate dès qu’on change d’onglet…
//       location.reload();
//    }
// })

function makeAsync(element) {

   let forms = element.querySelectorAll("[data-async-form]");

   forms.forEach(form => {
      const selects = form.querySelectorAll("select");

      selects.forEach(select => {

         select.addEventListener("change", event => {
            let formData = new FormData(form);
            let action = form.getAttribute("action");
            // form.action donne l’URL complète donc ça ne convient pas

            if (action === "/") {
               // Il faut "/" sans Javascript quand pretty URLs, sinon ça garde
               // toute l’URL et ça y ajoute les paramètres GET
               // Par contre, en JavaScript, il faut enlever ce / sinon on se
               // retrouve avec http://async?action=async-form
               action = "";
            }

            form.classList.add("content-loading");

            doXHR("POST",
               action + "/async?action=async-form",
               formData,
               responseText => {
                  if (responseText) {
                     try {
                        let response = JSON.parse(responseText);

                        if (response.output && response.new_url) {
                           // On remplace le HTML
                           if (typeof response.output === "string") {
                              form.parentNode.innerHTML = response.output;
                           } else {
                              Object.entries(response.output).forEach(pair => {
                                 let [selector, content] = pair;
                                 let element = document.querySelector(selector);
                                 if (element) {
                                    element.setAttribute("aria-live", "polite");
                                    element.innerHTML = content;
                                 }

                                 LADS.adjustResize();
                                 window.dispatchEvent(new CustomEvent("asyncload"));

                                 // On rend asynchrone le nouveau formulaire le cas échéant
                                 makeAsync(element);
                              });
                           }

                           form.classList.remove("content-loading");

                           // On change l’URL dans la barre d’adresse
                           history.replaceState(
                              {},
                              document.title,
                              response.new_url + window.location.hash
                           );

                           // On corrige dans tout le document les href des onglets
                           document.querySelectorAll("a[role='tab'][href]").forEach(a => {
                              if (a.href.indexOf("#") !== -1) {
                                 let hash = a.href.slice(a.href.indexOf("#"));
                                 let base = window.location.href.replace(window.location.hash, "");
                                 a.href = base + hash;
                              }
                              // Ces href vont passer de relatif (/o/42/Theatre-Blabla)
                              // à absolu (https://lads...net/o/42/Theatre-Blabla),
                              // mais pas grave, ça permet d’être à peu près sûr
                              // d’avoir la bonne adresse (sinon il faudrait enlever à
                              // document.URL le début, mais jusqu’où ? selon config)
                           });
                        }
                     } catch (err) {
                        alert("Une erreur est survenue.");
                        console.log(err);
                     }
                  } else {
                     alert("Une erreur est survenue.");
                  }
               }
            );
         });

      });
   });
}

LADS.callWhenDOMLoaded(() => {
   makeAsync(document.body);
});

})();

(function () {
   LADS.callWhenDOMLoaded(() => {
      // Mettre en place les événements fermer/ouvrir sur les éléments [data-toggle]
      if (document.querySelector(".fiche")) {
         document.querySelector(".fiche").addEventListener("click", event => {
            event.stopImmediatePropagation();
            const toggleButton = event.target.closest("[data-toggle]");
            if (toggleButton) {
               const target = toggleButton.dataset.toggle;
               const targetElements = document.querySelectorAll(target);

               // En chantier, faire un truc mieux
               // https://inclusive-components.design/collapsible-sections/

               const isExpanded = toggleButton.getAttribute("aria-expanded") === "true" || false;
               const shouldBeExpanded = !isExpanded;
               toggleButton.setAttribute("aria-expanded", shouldBeExpanded);
               targetElements.forEach(element => {
                  element.hidden = !shouldBeExpanded;
               });
            }
         });
      }

      init();
   });

   function init() {
      // Faire en sorte que l’état caché/visible corresponde bien
      // à l’état du toggle (icône et aria-expanded)
      document.querySelectorAll(".fiche [data-toggle]").forEach(toggleSource => {
         const targets = document.querySelectorAll(toggleSource.dataset.toggle);
         const isExpanded = toggleSource.getAttribute("aria-expanded") === "true" || false;
         targets.forEach(target => {
            target.hidden = !isExpanded;
         });
      });
   }

   window.addEventListener("asyncload", init);
})();

